





































import Vue, { PropOptions } from 'vue';
import IdsWaiting from '../components/IdsWaiting.vue';
import FailedIds from '../components/FailedIds.vue';
import LatestRun from '../components/LatestRun.vue';
import NextRun from '../components/NextRun.vue';
import Reschedule from '../components/Reschedule.vue';
import { useScheduled, useWorkflow, useMessages } from '../hooks';
import {
  createComponent,
  watch,
  ref,
  SetupContext,
} from '@vue/composition-api';

interface Store {
  state: {
    scheduleCount: number;
  };
}

interface SetupContextWithStore extends Omit<SetupContext, 'root'> {
  root: SetupContext['root'] & { $store: Store };
}

export default createComponent({
  props: {
    resource: {
      type: String,
      required: true,
    },
  },
  components: {
    IdsWaiting,
    FailedIds,
    LatestRun,
    NextRun,
    Reschedule,
  },
  setup(props, ctx: SetupContextWithStore) {
    const { scheduled, getScheduled } = useScheduled(props.resource);
    const { workflow, getWorkflow } = useWorkflow(props.resource);
    const { messages, getMessages } = useMessages(props.resource);

    async function getData() {
      await Promise.all([
        getWorkflow(props.resource),
        getScheduled(props.resource),
        getMessages(props.resource),
      ]);
    }

    // DON'T DO THAT.
    // This is a quick and dirty hack to marry Vuex's store with Composition API.
    // It made sense to do it like that this one time long time ago. But only then.
    // YOU SHOULD BE BETTER THAN ME.
    // https://github.com/S4RB/service-dashboard/pull/32#discussion_r428114878
    watch(
      () => ctx.root.$store.state.scheduleCount,
      async () => {
        await getData();
      },
    );

    watch(
      () => props.resource,
      async () => {
        await getData();
      },
    );

    return { scheduled, workflow, messages };
  },
});
